import React, { useState, useEffect } from 'react';
import { getGalleryImages } from '../../services/getAllApi'; // Import the API call
import '../../styles/Companies.css';

const Companies = () => {
  const [images, setImages] = useState([]); // State to store fetched images

  // Fetch images from the API
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await getGalleryImages("RecruiterCompanies"); // Use your API method here
     
        setImages(Array.isArray(response.data.images) ? response.data.images : []);
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };

    fetchImages(); // Fetch images when component mounts
  }, []);

  // Create alternating rows
  const firstRow = [];
  const secondRow = [];
  const thirdRow = [];

  images.forEach((image, index) => {
    if (index % 3 === 0) firstRow.push(image);
    else if (index % 3 === 1) secondRow.push(image);
    else thirdRow.push(image);
  });

  // LogoRow component for displaying the logos
  const LogoRow = ({ images, direction }) => (
    <div className={`flex whitespace-nowrap ${direction === 'left' ? 'animate-scroll-left' : 'animate-scroll-right'} hover:pause py-4 md:py-8`}>
      <div className="flex gap-[1rem] md:gap-[1rem]">
        {[...images, ...images].map((image, index) => (
          <div
            key={index}
            className="flex-shrink-0 w-44 md:w-64 h-24 md:h-32 flex justify-center items-center bg-white rounded-lg p-2 md:p-4 shadow-md transition-all duration-300 ease-in-out transform hover:shadow-2xl hover:scale-110 hover:z-10 hover:bg-gray-50"
          >
            <div className="w-[8rem] h-[8rem] flex items-center justify-center">
              <img
                src={`${"https://console.fbsedu.in/storage/app"}/${image.image_path}`}
                alt={`logo ${index + 1}`}
                className="w-full h-auto max-h-16 md:max-h-20 object-contain"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <>
      <div className="relative top-[2rem] w-full overflow-hidden">
        <style jsx global>{`
          @keyframes scroll-left {
            0% { transform: translateX(0); }
            100% { transform: translateX(-100%); }
          }
          
          @keyframes scroll-right {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(0); }
          }
          
          .animate-scroll-left {
            animation: scroll-left 60s linear infinite;
          }
          
          .animate-scroll-right {
            animation: scroll-right 60s linear infinite;
          }
          
          .hover:pause:hover {
            animation-play-state: paused;
          }
        `}</style>

        <div className="px-4 md:px-8">
          <p className="text-2xl md:text-4xl text-orange-600 font-bold">
            Our Leading Recruiters
          </p>
          <div className="w-[20rem] sm:w-[30rem] md:w-[35rem] h-[0.05rem] bg-orange-400"></div>
          <p className="my-2 md:my-3 text-base md:text-lg">
            Institutional alliances with leading companies to ensure a strong bonding with the industry and many more...
          </p>
        </div>

        <div className="mt-2 md:mt-15">
          <div className="overflow-hidden my-8 md:my-12">
            <LogoRow images={firstRow} direction="left" />
          </div>
          <div className="overflow-hidden my-8 md:my-12 relative lg:bottom-[6rem] sm:bottom-[1.5rem] md:bottom-[6rem]">
            <LogoRow images={secondRow} direction="right" />
          </div>
          <div className="overflow-hidden my-8 md:my-12 relative lg:bottom-[12rem] sm:bottom-[3rem] md:bottom-[12rem]">
            <LogoRow images={thirdRow} direction="left" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Companies;
